export type Tag = 'button' | 'a'

export type Variant =
  | 'primary'
  | 'secondary'
  | 'ghost'
  | 'bright'
  | 'tertiary'

export enum EVARIANT_BUTTON {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  GHOST = 'ghost',
  BRIGHT = 'bright',
  TERTIARY = 'tertiary'
}

export type Size = 'small' | 'big'

export interface IProps {
  variant?: Variant;
  size?: Size;
  border?: string;
  to?: string;
  target?: string;
  disabled?: boolean;
}

export interface IButtonProps extends IProps {}

export interface IEmits {
  (e: string): void;
}
